import { Button, Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import axios from "axios";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { baseUrl, mainBaseUrl } from "../../App";
import icon from "../../Images/Logout.png";
import Loader from "../../Loader";

const LogoutBtn = () => {
  const [load, setLoad] = useState(false);
  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const history = useHistory();
  const routeLogout = (e) => {
    history.push({
      pathname: "/",
    });
  };

  const logoutHandler = () => {
    setLoad(true);
    var config = {
      method: "post",
      url: `${mainBaseUrl}/users/logout`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-Key": baseUrl,
      },
    };

    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        localStorage.removeItem("token");
        handleClose();
        setLoad(false);
        routeLogout();
      })
      .catch(function (e) {
        setLoad(false);
        console.log(JSON.stringify(e.response.data));
      });
  };

  const logoutAllHandler = () => {
    setLoad(true);
    var config = {
      method: "post",
      url: `${mainBaseUrl}/users/logoutAll`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-Key": baseUrl,
      },
    };

    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        localStorage.removeItem("token");
        handleClose();
        setLoad(false);
        routeLogout();
      })
      .catch(function (e) {
        setLoad(false);
        console.log(JSON.stringify(e.response.data));
      });
  };

  return load ? (
    <Loader />
  ) : (
    <div className="user-logout">
      <img src={icon} />
      <p className="logout" onClick={handleClickOpen}>
        Logout
      </p>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Logout</DialogTitle>
        <DialogContent>
          <Button onClick={logoutHandler}>Logout</Button>
          <Button onClick={logoutAllHandler}> Logout All </Button>
          <Button onClick={handleClose}> Cancel </Button>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default LogoutBtn;
